/**
 * SaveDialog — modal to save the current filter configuration.
 */
import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Save } from 'lucide-react';

export default function SaveDialog({ open, onClose, onSave }) {
  const [name, setName] = useState('');
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-xs" data-testid="save-filter-dialog">
        <DialogHeader><DialogTitle className="text-sm">Save Filter</DialogTitle></DialogHeader>
        <div className="space-y-2 py-1">
          <Label className="text-xs font-semibold">Filter Name</Label>
          <Input value={name} onChange={e => setName(e.target.value)} placeholder="e.g. Q1 Adobe POs > $5k"
            className="h-8 text-sm" autoFocus onKeyDown={e => { if (e.key === 'Enter' && name.trim()) onSave(name.trim()); }}
            data-testid="save-filter-name" />
          <div className="flex gap-2 pt-1">
            <Button size="sm" onClick={() => { if (name.trim()) onSave(name.trim()); }} disabled={!name.trim()} data-testid="save-filter-confirm">
              <Save className="h-3.5 w-3.5 mr-1" /> Save
            </Button>
            <Button size="sm" variant="outline" onClick={onClose}>Cancel</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
